import { createRouter, createWebHistory } from "vue-router";
import Layout from "../components/Layout/index.vue";
import Home from "../views/Home/index.vue";
import AboutUs from "../views/AboutUs/index.vue";
import Doctors from "../views/Doctors/index.vue";
import Departments from "../views/Departments/index.vue";
import News from "../views/Mews/index.vue";
import NewsInfo from "../views/NewsInfo/index.vue";
// import CardiovascularMedicine from "../views/CardiovascularMedicine/index.vue";

import Management from "../views/Management/index.vue";
import { consumeManagementNavigationAuthorization } from "../utils/managementAccess";
const routes = [
  {
    path: "/",
    component: Layout,
    children: [
      {
        path: "",
        name: "Home",
        component: Home,
      },
      {
        path: "about-us",
        name: "AboutUs",
        component: AboutUs,
      },
      {
        path: "doctors/:dept?",
        name: "Doctors",
        component: Doctors,
        props: (route: any) => ({
          dept: (route.params.dept as string) || "all",
        }),
      },
      {
        path: "departments/:group?",
        name: "Departments",
        component: Departments,
        props: (route: any) => ({
          dept: (route.params.group as string) || "all",
        }),
      },
      {
        path: "news",
        name: "News",
        component: News,
      },
      {
        path: "newsinfo",
        name: "NewsInfo",
        component: NewsInfo,
      },
      {
        path: "management",
        name: "Management",
        component: Management,
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(_to, _from, _savedPosition) {
    // 始终滚动到页面顶部
    return { top: 0 };
  },
});

router.beforeEach((to, _from) => {
  if (to.name === "Management") {
    const hasValidEntry = consumeManagementNavigationAuthorization();

    if (!hasValidEntry) {
      return { name: "Home" };
    }
  }
});

export default router;
